import React, { useState } from 'react';
import '../styles/ContactPage.css';

const ContactPage = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const response = await fetch('https://formspree.io/f/mrbqgarq', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    if (response.ok) {
      setIsSubmitted(true);
      e.target.reset();
    }
  };

  return (
    <div className="contact-page container">
      <h1>Contact Us</h1>
      <p>Have a question? Want to book a session? Reach out to us below!</p>

      <div className="contact-wrapper">
        {/* Left: Contact Info & Social Media */}
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <div className="info-pair">
            <span className="label">Email:</span>
            <span className="value">
              <a href="mailto:info@westchestermusiclab.com">info@westchestermusiclab.com</a>
            </span>
          </div>

          <div className="info-pair">
            <span className="label">Phone:</span>
            <span className="value">
              <a href="tel:+19148306885">(914) 830-6885</a>
            </span>
          </div>

          <div className="info-pair">
            <span className="label">Address:</span>
            <span className="value">174 E Boston Post Rd, Mamaroneck, NY 10543</span>
          </div>

          <h3>Follow Us</h3>
          <div className="social-icons">
            <a 
              href="https://www.facebook.com/profile.php?id=61576669315149" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Follow us on Facebook"
            >
              <i className="fab fa-facebook"></i>
            </a>
            {/* <a 
              href="https://www.instagram.com/yourpage" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a 
              href="https://www.twitter.com/yourpage" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Follow us on Twitter"
            >
              <i className="fab fa-twitter"></i>
            </a> */}
          </div>
        </div>

        {/* Right: Contact Form */}
        <div className="contact-form">
          <h2>Send Us a Message</h2>
          {isSubmitted ? (
            <div className="confirmation-popup">Thank you! Your message has been sent.</div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input type="text" name="name" placeholder="Your Name" required />
                <input type="email" name="email" placeholder="Your Email" required />
              </div>
              <textarea name="message" placeholder="Your Message" rows="4" required></textarea>
              <button type="submit">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
